import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { WaitDialog } from "../modules/dialogs/WaitDialog";
import { getOneInByTabla, postIn } from "../../services/crudCustom";
import { Avatar, Box, Button, CircularProgress, Container, CssBaseline, Dialog, DialogContent, DialogTitle, Grid, Paper, TextField, ThemeProvider, Typography, createTheme } from "@mui/material";
import { Send } from "@mui/icons-material";
import { SelectCountryAndRegion } from "../modules/ui/SelectCountryAndRegion";
import { SelectCustom } from "../modules/ui/SelectCustom";
import moment from "moment";
import validator from 'validator';
import Swal from "sweetalert2";
import { generateRef } from "../../helpers/generateRef";
import { sendEmail } from "../../services/sendEmail";
import { uploadFile } from "../../services/uploadFile";
import { setEmailBodyGeneral } from "../../helpers/setEmailBodyGeneral";
import { renderToString } from 'react-dom/server';



export const RegistroGeneral = () => {

    // El id va a ser el nombre de la tabla para este tipo de registros que no se cobran y son genericos
    let { id  } = useParams();

    // state para cargar info
    const [isWaiting, setIsWaiting] = useState(true);
    const [sendingForm, setSendingForm] = useState(false);
    const [isEventValid, setIsEventValid] = useState(true);
    
    // state para los datos del registro
    const [datosRegistro, setDatosRegistro] = useState({ });

    // state para los valores del formulario
    const [formValues, setFormValues] = useState({
        partApellidoPaterno: "",
        partApellidoMaterno: "",
        partNombres: "",
        partCorreo: "",
        partCorreoConfirma: "",
        partPais: "",
        partEstado: "",
        tipoRegistro: "",
        tipoRegistroDocURL: "",

        registroClaveProyecto: "",
        registroFecha: "",
        registroReferencia: "",

        infoAdicional: {}
    });
    const {
        partApellidoPaterno,
        partApellidoMaterno,
        partNombres,
        partCorreo,
        partCorreoConfirma,
    } = formValues;

    // Para el selector de tipoRegistro
    const [addCredential, setAddCredential] = useState(false);
    
    // state para el fileupload
    const [file, setFile] = useState({ file: undefined });


    // Cada que cambia el valor en cualquier control de formulario
    const handleInputChange = ({ target }) => {
        console.log(target.name, target.value);
        setFormValues({
            ...formValues,
            [target.name]: target.value,
        });
    };
    
    // Cada que cambia el pais y estado
    const handleCountryAndRegionChange = ({ country, region }) => {
        // console.log(country, region);
        setFormValues({
            ...formValues,
            partPais: country,
            partEstado: region,
        })
    }  

    // Para el selector de tipo de registro
    const handleTipoRegistroChange = ({ target }) => {
        // console.log(target.name, target.value);

        const { name, value } = target;
        switch (value) {
            case 'Participante externo':
                // console.log("externo", value);
                setAddCredential(false);
                break;
                
            default:
                    // console.log("default", value);
                    setAddCredential(true);
                break;
        }
        setFormValues({
            ...formValues,
            [name]: value,
        });
    }
    
    // Para el selector de archivo
    const handleFileInputChange = (e) => {    
        setFile({ file: e.target.files[0] });    
    };

    // Check whether any of the form fields are unedited
    const isSendButtonDisabled = () => (
        formValues.partApellidoPaterno.length === 0 ||
        formValues.partNombres.length === 0 ||
        formValues.partCorreo.length === 0 ||
        formValues.partCorreoConfirma.length === 0 ||
        formValues.partPais.length === 0 ||
        formValues.partEstado.length === 0 ||
        formValues.tipoRegistro.length === 0 ||
        (formValues.tipoRegistro !== 'Participante externo' && file.file === undefined) ||
        false
    );

    const handleCloseWaitingDialog = (_, reason) => {
        // console.log(reason);
        if (reason !== 'backdropClick') {
        }
    };


    const isFormValid = () => {

        // Campos de correo validos
        if ( !validator.isEmail(partCorreo) ) {
            Swal.fire("Correo electrónico inválido.", "El formato del correo electrónico es inválido.", "error");
            return false;
        }
        // Campos de correo  iguales
        if ( partCorreo !== partCorreoConfirma ) {
            Swal.fire("Confirmar correo electrónico.", "La confirmación de correo electrónico no coincide.", "error");
            return false;
        }

        return true;
    }


    const isDataProcessed = async() => {
        
        console.log(formValues);
        
        // subir archivo en caso de
        let urlArchivo = '';
        if (addCredential) {
            // - subir archivo en PDF
            const fileName = `${formValues.registroReferencia}_credencial.pdf`
            const resultUpload = await uploadFile({ file, fileName });
            console.log(resultUpload);

            if (resultUpload.exito === 0) {
                console.log('Error al subir archivo', resultUpload.message);
                return false;
            }
            urlArchivo = `https://eventos.cibnor.mx/registro/apiServiciosSIARF${ resultUpload.data }`;
        }

        // grabar a la base de datos
        const valuesToDB = {
            ...formValues,
            tipoRegistroDocURL: urlArchivo,
            infoAdicional: JSON.stringify(formValues.infoAdicional)
        };

        console.log({valuesToDB});

        const resultPost = await postIn({ table:'RegistroGeneral', values:valuesToDB });
        console.log(resultPost);
        if (resultPost.exito === 0) {
            console.log('Error al grabar en la DB', resultPost.message);
            return false;
        }

        // Enviar correo
        const msgbody = renderToString( setEmailBodyGeneral({ formValues: valuesToDB, datosRegistro }) );

        const emailResult = await sendEmail({
            "toemail": formValues.partCorreo,
            "subject": `Registro en línea | ${ datosRegistro.tituloEvento }`,
            "message": msgbody,
            "replyto": datosRegistro.correoEvento,
            "tocc": datosRegistro.correoEvento,
        });
        console.log(emailResult);

        return true;
    }

    // Del sweetalert, cuando el usuario decide "continuar"
    const continueConfirmed = async() => {

        setSendingForm(true);

        // Se procesa la info
        const resultDataProcessed = await isDataProcessed(); 
        console.log({resultDataProcessed});

        setSendingForm(false);

        // notificar al usuario la conclusion del registro
        if (resultDataProcessed) {
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                confirmButtonText: 'Visita la página web del centro',
                icon: 'success',
                text: 'Consulte su correo electrónico para más información.',
                title: "Sus datos han sido recibidos exitosamente",
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.replace('https://www.cibnor.gob.mx/');
                }
            }); 
        } else {
            // Notificar del error al usuario y enviar email a developer
            Swal.fire({
                allowEscapeKey: false,
                allowOutsideClick: false,
                title: "Sucedío un error en el servidor.",
                text: 'Disculpe el inconveniente, por favor reintente más tarde.',
                icon: 'error',
                showConfirmButton: false,
                footer: 'El area correspondiente ya ha sido notificada.'
            }); 

            sendEmail({
                "toemail": "jcollins@cibnor.mx",
                "subject": "[RegistroGeneral] Error",
                "message": formValues,
            });
        }
    }

    const handleSubmit = async (event) => {
        event.preventDefault();

        // Validar datos
        if ( !isFormValid() ) return false;

        // Mostrar confirm dialog
        Swal.fire({
            title: '¿Desea continuar?',
            text: "Por favor, confirme la información ingresada.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Continuar',
            cancelButtonText: 'Regresar',
        }).then((result) => {
            if (result.isConfirmed) continueConfirmed();
        })
    }


    // Obtenemos los datos del evento y establecemos datosRegistro
    useEffect(() => {
      
        document.title += ` | ${ id }`;

        const loadInitialData = async () => {

            // Recuperamos el evento
            const { exito, data } = await getOneInByTabla({ table: id });

            setIsWaiting(false);
            if (exito) {
                setDatosRegistro({...data[0]});
            } else {
                setIsEventValid(false);
                Swal.fire({
                    icon: 'error',
                    title: 'Oops...',
                    text: 'No existe el enlace, favor de confirmar la información.',
                    allowEscapeKey: false,
                    allowOutsideClick: false,
                    showConfirmButton: false,
                    footer: '<a href="https://www.cibnor.gob.mx/">Visita la página web del centro</a>',
                })
            }
        }
        loadInitialData();
        
    }, [ id ])
    
    useEffect(() => {
        setFormValues( formValues => ({ 
            ...formValues, 
            registroClaveProyecto: datosRegistro.claveProyecto, 
            registroFecha: moment().format('YYYY-MM-DDTHH:mm:ss'),
            registroReferencia: generateRef({ prefix:`${ datosRegistro.claveProyecto }` }),
        }))

    }, [ datosRegistro ])
    


    return (
        <ThemeProvider theme={createTheme()}>
            { isWaiting
            ? 
            <WaitDialog show={ true } />
            :
            isEventValid ?
                <Container component="main" maxWidth="sm" >
                <CssBaseline />
                <Box sx={{ mt: 1, mb: 4, display: "flex", flexDirection: "column", alignItems: "center", }} >
                    <Avatar
                        sx={{ width: 200, height: 200 }}
                        src={ datosRegistro.urlLogo }
                        variant="square" 
                    />
                    <Typography sx={{ fontSize: 20, fontWeight: 800 }}>REGISTRO INICIAL</Typography>
                    <Typography variant="h5" align='center' sx={{ mt: 1 }}>{ datosRegistro.tituloEvento }</Typography>
                </Box>

                <Box
                    component="form"
                    noValidate
                    onSubmit={ handleSubmit }
                    // sx={{ mt: 2 }}
                    autoComplete="off"
                    maxWidth="sm"
                >

                    {/* Participante */}
                    <Paper elevation={ 2 }>
                        <Grid container spacing={ 2 } sx={{ flexGrow: 1, p: 3 }}>

                            <Grid item xs={ 12 }>
                                <Typography variant="subtitle1" sx={{ pt: 0, fontWeight: 900 }} >Datos generales</Typography>
                            </Grid>
                            <Grid item xs={ 6 }>
                                <TextField
                                    fullWidth
                                    id="partApellidoPaterno"
                                    label={ `Apellido paterno` }
                                    name="partApellidoPaterno"
                                    required
                                    size="small"
                                    value={ partApellidoPaterno }
                                    onChange={ handleInputChange }
                                />
                            </Grid>
                            <Grid item xs={ 6 }>
                                <TextField
                                    fullWidth
                                    id="partApellidoMaterno"
                                    label={ `Apellido materno` }
                                    name="partApellidoMaterno"
                                    size="small"
                                    value={ partApellidoMaterno }
                                    onChange={ handleInputChange }
                                />
                            </Grid>
                            <Grid item xs={ 12 }>
                                <TextField
                                    fullWidth
                                    id="partNombres"
                                    label={ `Nombre(s)` }
                                    name="partNombres"
                                    required
                                    size="small"
                                    value={ partNombres }
                                    onChange={ handleInputChange }
                                />
                            </Grid>
                            <Grid item xs={ 12 }>
                                <TextField
                                    fullWidth
                                    id="partCorreo"
                                    label="Correo electrónico"
                                    name="partCorreo"
                                    required
                                    size="small"
                                    value={ partCorreo }
                                    onChange={ handleInputChange }
                                />
                            </Grid>
                            <Grid item xs={ 12 }>
                                <TextField
                                    fullWidth
                                    id="partCorreoConfirma"
                                    label="Confirmar correo electrónico"
                                    name="partCorreoConfirma"
                                    required
                                    size="small"
                                    value={ partCorreoConfirma }
                                    onChange={ handleInputChange }
                                />
                            </Grid>
                            {/* Pais y estado */}
                            <Grid item xs={ 12 }>
                                <SelectCountryAndRegion 
                                    parentCallback={ handleCountryAndRegionChange } 
                                    paddingH={ 0 }
                                    paddingV={ 0 }
                                    variant="outlined" 
                                />
                            </Grid>
                            {/* Tipo de registro [ trab, est, ext ] */}
                            <Grid item xs={6} >
                                <SelectCustom
                                    parentCallback={ handleTipoRegistroChange }
                                    name={ "tipoRegistro" }
                                    label={ "Tipo de registro" }
                                    options={[
                                        {value:'Trabajador CIBNOR', label:'Trabajador CIBNOR'},
                                        {value:'Estudiante CIBNOR', label:'Estudiante CIBNOR'},
                                        {value:'Estudiante externo', label:'Estudiante externo'},
                                        {value:'Participante externo', label:'Participante externo'},
                                    ]}
                                    required
                                />
                            </Grid>
                            {/* Documento probatorio, dependiendo lo seleccionado en tipoRegistro */}
                            <Grid item xs={ 12 } sx={{ display:(addCredential ? 'flex' : 'none')  }}>
                                <TextField
                                    type={ "file" }
                                    inputProps={{ accept:"application/pdf" }}
                                    fullWidth
                                    onChange={ e => handleFileInputChange(e) }
                                    helperText="Subir documento probatorio (credencial en archivo PDF) *"
                                    variant='standard'
                                />
                            </Grid>
                                
                        </Grid>
                    </Paper>

                    {/* Boton */}
                    <Grid container spacing={2} sx={{ pt: 3, pb: 3 }}>
                        <Grid item xs={12}>
                            <Paper elevation={2} >
                                <Button
                                    type="submit"
                                    fullWidth
                                    endIcon={<Send />}
                                    disabled={ isSendButtonDisabled() }
                                >
                                    Enviar
                                </Button>
                            </Paper>
                        </Grid>
                    </Grid>
                </Box>
                </Container>  
                : <></>
            }
            {/* <WaitDialog show={ isWaiting } /> */}

            
            {/* Dialogo de espera porque se esta enviando la informacion */}
            <Dialog open={ sendingForm }
                onClose={ handleCloseWaitingDialog }
                disableEscapeKeyDown={ true }
                >
                <DialogTitle id="alert-dialog-title" >
                    {"Enviando información..."}
                </DialogTitle>
                <DialogContent sx={{
                                margin: 2,
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                            }}>
                    <CircularProgress />
                </DialogContent>
            </Dialog>

        </ThemeProvider>
    );
};
